<template>
  <div class="vue-wrap">
    <NavProgress :step="progress.step"></NavProgress>
    <h1 v-if="hasErrors">{{ httpErrors }}</h1>
    <section :id="progress.calendar.name">
      <Search v-if="selectedRooms.length == 0 && isLoading == false" :disabledDates="disabledDates"
        :minPriceDates="minPriceDates" :preselectedDays="preselectedDays" @searchRooms="searchRooms" />
      <SearchSummary v-if="selectedRooms.length > 0" />
    </section>
    <section :id="progress.bookables.name">
      <div v-if="bookables && bookables.length > 0">
        <hr />
        <h2><br />{{ $t("bookablesHeader") }} {{ $t("from") }} <br/> {{niceDate(params.dateFrom)}} {{ $t("to") }}
          {{niceDate(params.dateTo)}} <br /><br /></h2>
        <div v-for="(bookable, row) in bookables" :key="'row' + row">
          <BookableListItem :params="params" :nights="reservation.nights" v-bind="bookable" @selectedRoom="selectRoom">
          </BookableListItem>
        </div>
      </div>
    </section>

    <section v-if="selectedRooms && selectedRooms.length > 0" :id="progress.room_1.name">
      <div v-for="(selectedRoom, row) in selectedRooms" :key="'row' + row">
        <SelectedListItem :nights="reservation.nights" :roomIndex="row + 1" v-bind="selectedRoom"
          @unselectRoom="unselectRoom"></SelectedListItem>
      </div>
      <div v-if="showAnotherRoom">
        <SearchMore :startDate="params.dateFrom" :endDate="params.dateTo" @searchRooms="searchRooms"></SearchMore>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-md-auto">
          <button class="btn btn-primary btn-gradient btn-next" v-if="selectedRooms.length > 0 && progress.roomButton.show == true"
            @click="showAnotherRoom = false; progress.additionals.show = true; progress.roomButton.show = false; storeLocal(reservation); scrollToElement(progress.additionals.name, 500);">
            {{ $t("next") }}
          </button>
        </div>
      </div>
    </section>

    <section :id="progress.additionals.name">
      <Additionals v-show="progress.additionals.show" />
      <AdditionalsSummary v-show="progress.additionals.overview" />
    </section>

    <section :id="progress.contact.name">
      <OrderFormContact v-if="progress.contact.show == true" />
      <OrderFormSummary v-show="progress.contact.overview" />
    </section>

    <section :id="progress.overview.name">
      <FinalSummary v-if="progress.overview.show == true" />
    </section>
  </div>

  <!-- <div>
    <pre>{{ JSON.stringify(reservation, null, "\t") }}</pre>
  </div>
  <div>
    <button @click="getBasketInfo">getBasketInfo</button>
    <pre>{{ JSON.stringify(basketInfo, null, "\t") }}</pre>
  </div> -->

</template>


<script>
import NavProgress from "./NavProgress.vue";
import Search from "./Search.vue";
import SearchMore from "./SearchMore.vue";
import BookableListItem from "./BookableListItem.vue";
import SelectedListItem from "./SelectedListItem.vue";
import Additionals from "./Additionals.vue";
import AdditionalsSummary from "./AdditionalsSummary.vue";
import OrderFormContact from "./OrderFormContact.vue";
import OrderFormSummary from "./OrderFormSummary.vue";
import SearchSummary from "./SearchSummary.vue";
import FinalSummary from "./FinalSummary.vue";


export default {


  inject: ["reservation", "progress"],
  name: "AppWrapper",
  components: {
    Search,
    SearchMore,
    BookableListItem,
    SelectedListItem,
    NavProgress,
    Additionals,
    AdditionalsSummary,
    OrderFormContact,
    SearchSummary,
    OrderFormSummary,
    FinalSummary,
  },
  data() {
    return {

      showAnotherRoom: true,
      showDebug: true,
      // disabledDays: ["2022-05-10", "2022-05-11", "2022-05-12"],
      preselectedDays: ["2022-05-10", "2022-05-11", "2022-05-13"],
      bookables: [],
      isLoading: true,
      loader: null,
      selectedRooms: [],
      httpStatus: null,
      sessionID: 0,
      httpErrors: "Default",
      params: null,
      urlParameter: null,
      disabledDates: [],
      minPriceDates: [],
      basketInfo: null
    };
  },

  watch: {
    reservationData() {
      this.showDebug = !this.showDebug;
      this.res = this.reservation;
      return JSON.stringify(this.res, null, "\t");
    },
  },
  computed: {
    totalRooms() {
      var roomSum = 0.0;
      this.reservation.rooms.forEach((obj) => {
        roomSum += obj.selectedprice.price;
      });
      return roomSum;
    },
    totalAdditionals() {
      var additionalSum = 0;
      if (this.reservation.additionals.length > 1) {
        this.reservation.additionals.forEach((obj) => {
          additionalSum += obj.amount * obj.price;
        });
        return additionalSum;
      } else {
        return 0;
      }
    },
    total() {
      return this.totalRooms + this.totalAdditionals;
    },
    hasErrors() {
      var fruits = [400, 404, 500];
      fruits.includes(this.httpStatus);

      return fruits.includes(this.httpStatus);
    },
    hasErrors_old() {
      return 400 == this.httpStatus && this.httpErrors != null;
    },
    hasAvailability() {
      return 200 == this.httpStatus;
    },
    noAvailability() {
      return 404 == this.httpStatus;
    },
    hasServerError() {
      return 500 == this.httpStatus && this.httpErrors != null;
    },
  },

  methods: {

    loaderStart() {
      var lder = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.loadingContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      return lder;
    },

    loaderEnd(lder) {
      lder.hide();
      this.isLoading = false;
      document.body.classList.add("app-ready");
    },

    isLocalStorage() {
      var test = 'test';
      try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        console.log("localstorage yes");
        return true;
      } catch (e) {
        console.log("localstorage no");
        return false;
      }
    },


    logReservation() {
      // console.log(this.reservation);
    },
    childrenInRoom(n) {
      if (n === "") return null;
      return n.split(";").length;
    },

    logChange(event) {
      console.log(event);
    },
    scrollToMyEl(el) {
      const myEl = document.getElementById(el);

      this.$smoothScroll({
        scrollTo: myEl, // scrollTo is also allowed to be number
        updateHistory: false,
        // hash: "#sampleHash", // required if updateHistory is true
      });
    },
    resetAll() {
      window.location.reload();
    },


    searchRooms(p) {
      // store current params
      this.params = p;
 
      if (!this.isLoading ) { this.loader = this.loaderStart() }
      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.fullPage ? null : this.$refs.loadingContainer,
      //   canCancel: true,
      //   onCancel: this.onCancelLoading,
      //   opacity: 0.7,
      // });
      this.bookables = null;
      var dynamicList = [];
      var searchData = {
        search: {
          adults: p.adults,
          children: p.children,
          dateFrom: p.dateFrom,
          dateTo: p.dateTo,
          code: p.code,
          sessionID: this.sessionID,
          clearbasket: p.clearbasket
        },
      };
      this.axios
        .post(this.url + "/rest/v1/search", searchData, {
          withCredentials: true,
        })
        .then((response) => {
          this.httpStatus = response.status;
          // console.log(response);
          // this.$cookies.set("fe_typo_user", response.data.sessionId);
          this.bookables = Object.values(response.data.roomCategories);
          this.bookables.forEach((element) => {
            dynamicList.push({
              ...element,
              visible: true,
              selected: false,
            });
          });
          this.bookables = dynamicList;
          this.reservation.startdate = response.data.dates.from;
          this.reservation.enddate = response.data.dates.to;
          this.reservation.nights = response.data.nrOfNights;
          this.reservation.sessionId = response.data.sessionId;
          this.sessionID = response.data.sessionId;
          this.progress.calendar.overview = true;
          this.progress.bookables.show = true;
          setTimeout(() => {
            this.scrollToElement(this.progress.bookables.name);
          }, 500);
        })
        .catch((error) => {
          console.log(error.response);
          console.log(error.response.status);

          if (400 == error.response.status) {
            this.httpErrors = error.response.data.message;
            this.httpStatus = error.response.status;
    
            this.loaderEnd(this.loader)
          }
          if (404 == error.response.status) {
            // console.log(error.response.data.code);
            // console.log(error.response.data.message);
            this.httpErrors = error.response.data.message;
            this.httpErrors = this.$t("nothing-found-404");
            this.httpStatus = error.response.status;
            // upwork
            this.loaderEnd(this.loader)
          }
          if (500 == error.response.status) {
            this.httpErrors = error.response.data.message;
            this.httpStatus = error.response.status;
            //upwork
            this.loaderEnd(this.loader)
          }
          this.httpStatus = error.response.status;
        })
        //upwork
        .then(() => this.loaderEnd(this.loader));
        

    },
    getBasketInfo() {
      this.axios
        .post(this.url + "/rest/v1/info")
        .then((response) => {
          this.status = response.status;
          this.basketInfo = response.data;

        });

    },
    // local

    selectRoom(e) {
      // check if local, sessionid does not work
      var host = window.location.hostname;
      if (host == "192.168.0.185") {
        this.selectRoomLocal(e)
      } else {
        // this.selectRoomLocal(e)
        this.selectRoomOnline(e)
      }
    },

    selectRoomLocal(e) {
      var key = "123456";
      // set adult and children ages
      var adultlist = [];
      var childrenlist = [];
      for (var i = 0; i < this.params.adults; i++) { adultlist.push({}); }
      if (this.childrenInRoom(this.params.children)) {
        console.log();
        var j = this.childrenInRoom(this.params.children);
        for (i = 0; i < j; i++) {
          childrenlist.push({});
        }
      }
      // add roomcat to selected rooms
      var idx = this.bookables.findIndex((obj) => obj.code == e.code);
      this.selectedRooms.push(this.bookables[idx]);
      // add query params for this selected room plus key
      this.selectedRooms[this.selectedRooms.length - 1].adults =
        this.params.adults.toString();
      this.selectedRooms[this.selectedRooms.length - 1].childrenages = this.params.children.toString();
      console.log("key");
      console.log(key);
      this.selectedRooms[this.selectedRooms.length - 1].apikey = key.toString();
      var selectedprice = { price: e.price, rateplan: e.rateplan };
      this.selectedRooms[this.selectedRooms.length - 1].selectedprice = selectedprice;

      // add room to reservation
      this.reservation.rooms.push({
        key: key,
        code: this.bookables[idx].code,
        selectedprice: { price: e.price, rateplan: e.rateplan },
        title: this.bookables[idx].title,
        adults: this.params.adults,
        childrenages: this.params.children,
        adultlist: adultlist,
        childrenlist: childrenlist,
      });
      this.reservation.totalRooms = this.total;
      this.reservation.total_selected_payment = (this.reservation.totalRooms * this.reservation.percent_payment) / 100;
      //clear bookables
      this.bookables.length = 0;
      this.progress.bookables.show = false;
      this.progress.step = 1;

      setTimeout(() => {
        this.scrollToElement(this.progress.room_1.name);
      }, 500);
    },

    selectRoomOnline(e) {
      var key = "";
      
      if (!this.isLoading ) { this.loader = this.loaderStart() }
     
      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.fullPage ? null : this.$refs.loadingContainer,
      //   canCancel: false,
      //   onCancel: this.onCancelLoading,
      //   opacity: 0.9,
      // });

      var postData = {
        create: {
          code: e.code,
          rateplan: e.rateplan,
          sessionID: this.sessionID,
        },
      };

      this.axios
        .post(this.url + "/rest/v1/create", postData, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response);
          key = response.data.key;
          console.log(key);
          // set adult and children ages
          var adultlist = [];
          var childrenlist = [];
          for (var i = 0; i < this.params.adults; i++) { adultlist.push({}); }
          if (this.childrenInRoom(this.params.children)) {
            var j = this.childrenInRoom(this.params.children);
            for (i = 0; i < j; i++) {
              childrenlist.push({});
            }
          }
          // add roomcat to selected rooms
          var idx = this.bookables.findIndex((obj) => obj.code == e.code);
          this.selectedRooms.push(this.bookables[idx]);
          // add query params for this selected room plus key
          this.selectedRooms[this.selectedRooms.length - 1].adults =
            this.params.adults.toString();
          this.selectedRooms[this.selectedRooms.length - 1].childrenages = this.params.children.toString();
          this.selectedRooms[this.selectedRooms.length - 1].apikey = key.toString();
          var selectedprice = { price: e.price, rateplan: e.rateplan };
          this.selectedRooms[this.selectedRooms.length - 1].selectedprice = selectedprice;

          // add room to reservation
          this.reservation.rooms.push({
            key: key,
            code: this.bookables[idx].code,
            selectedprice: { price: e.price, rateplan: e.rateplan },
            title: this.bookables[idx].title,
            adults: this.params.adults,
            childrenages: this.params.children,
            adultlist: adultlist,
            childrenlist: childrenlist,
          });
          this.reservation.totalRooms = this.total;
          this.reservation.total_selected_payment = (this.reservation.totalRooms * this.reservation.percent_payment) / 100;
          //clear bookables
          this.bookables.length = 0;
          this.progress.bookables.show = false;
          this.progress.step = 1;

          if (this.isLoading ) { this.loaderEnd(this.loader )}

        })
        .catch((error) => {
 

          if (400 == error.response.status) {
            // this.error = error.response.data.message;
            this.httpErrors = error.response.data.message;
        
            //this.loaderEnd(this.loader)
          }
          if (404 == error.response.status) {
            this.httpErrors = error.response.data.message;
            this.httpErrors = this.$t("nothing-found-404");
            this.httpStatus = error.response.status;
          
            //this.loaderEnd(this.loader)
          }
          if (500 == error.response.status) {
            this.httpErrors = error.response.data.message;
            this.httpStatus = error.response.status;
            key = "123456";
           
            //this.loaderEnd(this.loader)
          }
          this.httpStatus = error.response.status;
        })
        .then(() => {
          
          this.loaderEnd(this.loader)
          setTimeout(() => {
            this.scrollToElement(this.progress.room_1.name);
          }, 500);
        });




      return true;
    },

    unselectRoom(e) {
     
      //if (!this.isLoading ) { this.loader = this.loaderStart() }
      // let loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.fullPage ? null : this.$refs.loadingContainer,
      //   canCancel: true,
      //   onCancel: this.onCancelLoading,
      // });


      // find the apikey
      var idx = this.selectedRooms.findIndex((obj) => obj.apikey == e);
      // get the code for bookables
      var code = this.selectedRooms[idx].code;
      // remove the roomcat from selected
      this.selectedRooms.splice(idx, 1);
      // check if there is another room with this code, if so dont touch bookables
      idx = this.selectedRooms.findIndex((obj) => obj.code == code);

      idx = this.reservation.rooms.findIndex((obj) => obj.key == e);
      this.reservation.rooms.splice(idx, 1);
      // set new roomtotal
      this.reservation.totalRooms = this.total;
      this.reservation.total_selected_payment = (this.reservation.totalRooms * this.reservation.percent_payment) / 100;
      var postData = { remove: { key: e } };
      this.axios
        .post(this.url + "/rest/v1/remove", postData)
        .then((response) => {
          console.log(response);
          if (this.reservation.rooms.length == 0) {
            //this.check(this.params);
            this.resetAll();
          }
        })
        .catch((error) => {
          //   console.log(error.response.data);
          //   console.log(error.response.status);

          if (400 == error.response.status) {
            // this.error = error.response.data.message;
            this.httpErrors = error.response.data.message;
          }
          if (404 == error.response.status) {
            // this.error = error.response.data.message;
            this.httpErrors = error.response.data.message;
          }
          if (500 == error.response.status) {
            this.httpErrors = error.response.data.message;
          }
          this.httpStatus = error.response.status;
        })
    
            //.then(() => this.loaderEnd(this.loader));
    },
  },
  created() {
    // #DZFH,2022-05-25,2022-05-27
    var validUrl = false

    this.loader = this.loaderStart()

    this.axios
      .post(this.url + "/rest/v1/occupancy")
      .then((response) => {
        this.status = response.status
        var daysObject = response.data;
        delete daysObject.sessionId;
        this.disabledDates = Object.keys(daysObject).map(function (key) { return daysObject[key] })
      })
      .then(() => {
        var urlP = []
        const urlSearchParams = new URLSearchParams(location.search);
        const urlParams = Object.fromEntries(urlSearchParams)

        if (urlSearchParams && urlSearchParams.size === 3 && urlParams) {
          const { startDate, endDate, roomCode } = urlParams;
          urlP = {
            dateFrom: startDate,
            dateTo: endDate,
            adults: 2,
            children: "",
            code: roomCode,
          }
          validUrl = true
        }
        //validUrl = false
        if (validUrl) {
          this.searchRooms(urlP)
        } else {
      
            this.loaderEnd(this.loader)
        }
      })

  },
  mounted() {
    //this.isLoading = false
    // console.log("this.disabledDates")
    // console.log(this.disabledDates)
  }
};

</script>